var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1000px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.orderDatalist
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "detailHead" }, [
                    _c("div", { staticClass: "full" }, [
                      _c("div", { staticClass: "order_icon" }, [
                        _c("span", { staticClass: "iconfont icon-dingdan" }),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _c("div", { staticClass: "acea-row" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("orderTypeFilter")(
                                  _vm.orderDatalist.type
                                )
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "ml5" }, [_vm._v(" 一 ")]),
                          _c("div", { staticClass: "title ml5" }, [
                            _vm.orderDatalist.secondType === 5 ||
                            _vm.orderDatalist.secondType === 6
                              ? _c("div", { staticClass: "value" }, [
                                  _vm._v("自动发货"),
                                ])
                              : _vm.orderDatalist.secondType === 2
                              ? _c("div", { staticClass: "value" }, [
                                  _vm._v("虚拟发货"),
                                ])
                              : _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("shippingTypeFilter")(
                                        _vm.orderDatalist.shippingType
                                      )
                                    )
                                  ),
                                ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v(
                              "订单号：" + _vm._s(_vm.orderDatalist.orderNo)
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("ul", { staticClass: "list" }, [
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("订单状态"),
                        ]),
                        _c("div", { staticClass: "color-warning" }, [
                          _vm.orderDatalist.refundStatus === 3
                            ? _c("span", [_vm._v("已退款")])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("orderStatusFilter")(
                                      _vm.orderDatalist.status
                                    )
                                  )
                                ),
                              ]),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("实际支付"),
                        ]),
                        _c("div", [
                          _vm._v(
                            "¥ " + _vm._s(_vm.orderDatalist.payPrice || "0.0")
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("支付方式"),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm._f("payTypeFilter")(_vm.orderDatalist.payType)
                            )
                          ),
                        ]),
                      ]),
                      _c("li", { staticClass: "item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("支付时间"),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm._f("filterEmpty")(_vm.orderDatalist.payTime)
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "订单信息", name: "detail" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "detailSection",
                              staticStyle: { border: "none" },
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("用户信息"),
                              ]),
                              _c("ul", { staticClass: "list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("用户名称："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(_vm.orderDatalist.nickname) +
                                        " | " +
                                        _vm._s(_vm.orderDatalist.uid)
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("用户电话："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.orderDatalist.phone)),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.orderDatalist.shippingType < 2 &&
                                    _vm.orderDatalist.secondType !== 2,
                                  expression:
                                    "orderDatalist.shippingType < 2 && orderDatalist.secondType !== 2",
                                },
                              ],
                              staticClass: "detailSection",
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("收货信息"),
                              ]),
                              _c("ul", { staticClass: "list" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("收货人："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.orderDatalist.realName) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("收货电话："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.orderDatalist.userPhone) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("收货地址："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.orderDatalist.userAddress) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("订单信息"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商品总价："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.proTotalPrice)
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商品总数："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDatalist.totalNum)),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("平台优惠金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.platCouponPrice)
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付状态："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.paid
                                        ? "已支付"
                                        : "未支付"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("实际支付："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.payPrice || "0.0")
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商户优惠金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.merCouponPrice || "0.0"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("会员抵扣金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.svipDiscountPrice ||
                                        "0.0"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付邮费："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDatalist.payPostage)),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("赠送积分："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDatalist.gainIntegral)
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("积分抵扣金额："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDatalist.integralPrice || "0.0"
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付方式："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("payTypeFilter")(
                                        _vm.orderDatalist.payType
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("支付时间："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.payTime
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("买家留言"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.userRemark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "detailSection" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("商家备注"),
                            ]),
                            _c("ul", { staticClass: "list" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterEmpty")(
                                        _vm.orderDatalist.merchantRemark
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm.orderExtend.length
                            ? _c("div", { staticClass: "detailSection" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("自定义留言"),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "orderExtends" },
                                  _vm._l(
                                    _vm.orderExtend,
                                    function (items, indexs) {
                                      return _c("li", { key: indexs }, [
                                        items.length
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                items,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "item",
                                                    },
                                                    [
                                                      _c("system-from-info", {
                                                        attrs: { item: item },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "tabBox",
                          attrs: { label: "商品信息", name: "goods" },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "mt20 orderDetailList",
                              attrs: {
                                data: _vm.orderDatalist.orderDetailList,
                                size: "small",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "商品信息",
                                  "min-width": "400",
                                  "show-overflow-tooltip": true,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview mr15",
                                                },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                      "preview-src-list": [
                                                        scope.row.image,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "408px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "line1 mb10",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.productName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "line1 color-909399 line-heightOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "规格：" +
                                                          _vm._s(scope.row.sku)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3000418444
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "商品售价", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line1" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(scope.row.price) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3355191556
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "购买数量", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line1" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(scope.row.payNum) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1311105687
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label:
                                    _vm.orderDatalist.shippingType == 2
                                      ? "核销数量"
                                      : "发货数量",
                                  "min-width": "90",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line1" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.deliveryNum
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2748337827
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "售后数量", "min-width": "90" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "line1 mb10 line-heightOne",
                                                },
                                                [
                                                  _vm._v(
                                                    "退款中：" +
                                                      _vm._s(
                                                        scope.row.applyRefundNum
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "line1 line-heightOne",
                                                },
                                                [
                                                  _vm._v(
                                                    "退款成功：" +
                                                      _vm._s(
                                                        scope.row.refundNum
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3303383597
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.orderDatalist.secondType ===
                      _vm.OrderSecondTypeEnum.Reservation
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: { label: "预约信息", name: "reservation" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "detailSection",
                                  staticStyle: { border: "none" },
                                },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("预约信息"),
                                  ]),
                                  _c("ul", { staticClass: "list" }, [
                                    _c("li", { staticClass: "item" }, [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("联系人："),
                                      ]),
                                      _c("div", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(_vm.orderDatalist.realName)
                                        ),
                                      ]),
                                    ]),
                                    _c("li", { staticClass: "item" }, [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("联系电话："),
                                      ]),
                                      _c("div", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(_vm.orderDatalist.userPhone)
                                        ),
                                      ]),
                                    ]),
                                    _c("li", { staticClass: "item" }, [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("预约时间："),
                                      ]),
                                      _c("div", { staticClass: "value" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservationInfo
                                                .reservationDate
                                            )
                                          ),
                                        ]),
                                        _c("span", { staticClass: "ml10" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservationInfo
                                                .reservationTimeSlot
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.orderDatalist.shippingType ===
                                            5,
                                          expression:
                                            "orderDatalist.shippingType === 5",
                                        },
                                      ],
                                      staticClass: "item",
                                    },
                                    [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("上门地址："),
                                      ]),
                                      _c("div", { staticClass: "value" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.orderDatalist.userAddress
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.orderDatalist.status > 1 &&
                      _vm.orderDatalist.status < 9 &&
                      _vm.orderDatalist.secondType < 5 &&
                      _vm.orderDatalist.status !== 3
                        ? _c(
                            "el-tab-pane",
                            {
                              staticClass: "tabBox",
                              attrs: { label: "发货记录", name: "delivery" },
                            },
                            [
                              _vm._l(_vm.InvoiceList, function (item) {
                                return [
                                  _vm.InvoiceList.length
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              key: item.id,
                                              staticClass: "mt20",
                                              attrs: {
                                                data: item.detailList,
                                                size: "small",
                                              },
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { "min-width": "400" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "header",
                                                      fn: function (scope) {
                                                        return [
                                                          item.deliveryType ===
                                                          "express"
                                                            ? [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-color",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "【快递配送】"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.expressName +
                                                                        "：" +
                                                                        item.trackingNumber
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml30",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.createTime
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : item.deliveryType ===
                                                              "merchant"
                                                            ? [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-color",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "【商家送货】"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.deliveryCarrier +
                                                                        "：" +
                                                                        item.carrierPhone
                                                                    )
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml30",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.createTime
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-color",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "【" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .orderDatalist
                                                                            .secondType ===
                                                                            _vm
                                                                              .OrderSecondTypeEnum
                                                                              .Fictitious
                                                                            ? "虚拟发货"
                                                                            : "无需配送"
                                                                        ) +
                                                                        "】"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.createTime
                                                                    )
                                                                  ),
                                                                ]),
                                                              ],
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "acea-row row-middle",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "demo-image__preview mr15",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-image",
                                                                    {
                                                                      attrs: {
                                                                        src: scope
                                                                          .row
                                                                          .image,
                                                                        "preview-src-list":
                                                                          [
                                                                            scope
                                                                              .row
                                                                              .image,
                                                                          ],
                                                                        fit: "cover",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "408px",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "line1 mb10 line-heightOne",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          scope
                                                                            .row
                                                                            .productName
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "line1 color-909399 line-heightOne",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "规格：" +
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .sku
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "acea-row row-middle ml30",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "line1 font12 color-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "X " +
                                                                          _vm._s(
                                                                            scope
                                                                              .row
                                                                              .num
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  width: "400",
                                                  fixed: "right",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "header",
                                                      fn: function (scope) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex mr10",
                                                              staticStyle: {
                                                                "justify-content":
                                                                  "flex-end",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "hasPermi",
                                                                      rawName:
                                                                        "v-hasPermi",
                                                                      value: [
                                                                        "merchant:order:invoice:update",
                                                                      ],
                                                                      expression:
                                                                        "['merchant:order:invoice:update']",
                                                                    },
                                                                  ],
                                                                  staticStyle: {
                                                                    "line-height":
                                                                      "1",
                                                                    height:
                                                                      "auto",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleEditLogistics(
                                                                          item
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "修改配送信息 "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.checkPermi([
                                                                "merchant:order:logistics:info",
                                                              ]) &&
                                                              item.deliveryType ===
                                                                "express"
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "ml20",
                                                                      staticStyle:
                                                                        {
                                                                          "line-height":
                                                                            "1",
                                                                          height:
                                                                            "auto",
                                                                        },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.openLogistics(
                                                                              item.id,
                                                                              item.expressName
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "查看物流 "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return item.deliveryType ===
                                                          "noNeed"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "acea-row row-middle",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "font12 color-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "发货备注：" +
                                                                          _vm._s(
                                                                            item.deliveryMark
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : undefined
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              }),
                              _vm.orderDatalist.status > 4 &&
                              _vm.orderDatalist.status < 9 &&
                              _vm.orderDatalist.shippingType === 2
                                ? _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "detailSection" },
                                      [
                                        _c("ul", { staticClass: "list" }, [
                                          _c("li", { staticClass: "item" }, [
                                            _c("div", [_vm._v("核销员名称：")]),
                                            _c(
                                              "div",
                                              { staticClass: "value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.orderDatalist.clerkName
                                                  ) +
                                                    " | " +
                                                    _vm._s(
                                                      _vm.orderDatalist.clerkId
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("li", { staticClass: "item" }, [
                                            _c("div", [_vm._v("核销时间：")]),
                                            _c(
                                              "div",
                                              { staticClass: "value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.orderDatalist.verifyTime
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.modal2, width: "600px" },
              on: {
                "update:visible": function ($event) {
                  _vm.modal2 = $event
                },
              },
            },
            [
              _c("div", { staticClass: "logistics acea-row row-top" }, [
                _c("div", { staticClass: "logistics_img" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/imgs/expressi.jpg") },
                  }),
                ]),
                _c("div", { staticClass: "logistics_cent" }, [
                  _c("span", { staticClass: "mb10" }, [
                    _vm._v("物流公司：" + _vm._s(_vm.expressName)),
                  ]),
                  _c("span", [
                    _vm._v("物流单号：" + _vm._s(_vm.resultInfo.number)),
                  ]),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [_vm._v("快递站：" + _vm._s(_vm.resultInfo.courierPhone))]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "快递员电话：" + _vm._s(_vm.resultInfo.courierPhone)
                      ),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "acea-row row-column-around trees-coadd" },
                [
                  _c(
                    "div",
                    { staticClass: "scollhide" },
                    [
                      _c(
                        "el-timeline",
                        { attrs: { reverse: _vm.reverse } },
                        _vm._l(_vm.result, function (item, i) {
                          return _c("el-timeline-item", { key: i }, [
                            _c("p", {
                              staticClass: "time",
                              domProps: { textContent: _vm._s(item.time) },
                            }),
                            _c("p", {
                              staticClass: "content",
                              domProps: { textContent: _vm._s(item.status) },
                            }),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("editDelivery", {
        attrs: {
          visible: _vm.editDeliveryDialogVisible,
          editData: _vm.editData,
        },
        on: {
          onCloseVisible: _vm.onCloseVisible,
          onSubmitSuccess: _vm.onSubmitSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }